import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-band-card',
  templateUrl: './band-card.component.html',
  styleUrls: ['./band-card.component.scss']
})
export class BandCardComponent {

  @Input() bandeira: any;

}
